module.exports = "./img/ac6fc66db88afb15c90e2ef6b23bede7.jpg";